<svg:rect
  appDataCy="production-schedule-colored-yarn-set"
  x="0"
  y="0"
  [attr.height]="productionScheduleBuilderHeight"
  class="production-schedule-colored-yarn-set-background background"
  #productionScheduleColoredYarnSetBackground
></svg:rect>

<svg:rect class="production-schedule-colored-yarn-set-separator" width="1" height="100%" x="calc(100% - 1px)"></svg:rect>

<ng-container *ngIf="hasPermissionToNewVerifyStep()">
  <svg:svg
    app-production-schedule-path-of-colored-yarn-set-new
    class="production-schedule-path-of-colored-yarn-set"
    *ngFor="let productionSchedulePath of productionSchedulePathsOfColoredYarnSet.productionSchedulePaths; let productionSchedulePathIndex = index; trackBy: trackByProductionSchedulePath"
    [productionSchedulePhase]="productionSchedulePhase"
    [productionSchedulePathsOfColoredYarnSet]="productionSchedulePathsOfColoredYarnSet"
    [productionScheduleColoredYarnSetIndex]="productionScheduleColoredYarnSetIndex"
    [commercialUnit]="commercialUnit"
    [productionScheduleBuilderHeight]="productionScheduleBuilderHeight"
    [productionSchedule]="productionSchedule"
    [aspectRatio]="aspectRatio"
    [productionSchedulePath]="productionSchedulePath"
    [productionSchedulePathIndex]="productionSchedulePathIndex"
    [isEditPathsEnabled]="isEditPathsEnabled"
    [productionOrderCustomSettings]="productionOrderCustomSettings"
    [isProductionScheduleDisplayOverview]="isProductionScheduleDisplayOverview"
    (hoveredProductionSchedulePathComponent)="onHoveredProductionSchedulePathComponent($event)"
    (productionSchedulePlanChanged)="onProductionSchedulePlanChanged()"
    appDataCy="production-schedule-path-of-colored-yarn-set"
  ></svg:svg>
</ng-container>

<svg:svg class="production-schedule-colored-yarn-set-error-overlay" (click)="onClickProductionScheduleColoredYarnSetErrorOverlay($event)" *ngIf="canShowProductionScheduleColoredYarnSetErrorOverlay()">
  <svg:rect [attr.height]="productionScheduleBuilderHeight" [attr.width]="getProductionScheduleColoredYarnSetWidth()"></svg:rect>
  <svg:image
    class="production-schedule-colored-yarn-set-error-icon"
    x="50%"
    y="50%"
    transform="translate(-20, -20)"
    width="40"
    height="40"
    href="assets/icons/illustrations/error-with-container.svg"
  ></svg:image>
</svg:svg>
